import Table from "../Plugin/MasterKongTable.vue";
import imgOn from "../../../assets/images/mapOn.png"
import imgOff from "../../../assets/images/mapOff.png"
import imgDisable from "../../../assets/images/mapDisable.png"
import linegraph from "../../../components/linegraph.vue"
import * as echarts from "echarts"
import moment from "moment";
import screenfull from "screenfull";

export default {
  name: "test",
  components: {
    Table,
    linegraph
  },
  data() {
    return {
      carOption: {},
      carLoading: false,
      isValue: true,
      carCount: '',
      likeCount: '',
      offlineCount: '',
      problemCount: '',

      companyStatusLoading: false,
      companyStatusOption: {},

      DriverStatusLoading: false,
      DriverStatusOption: {},
      driverCount: '',
      driverWorkCount: '',
      driverNoWorkCount: '',

      DriverStatisticsLoading: false,
      DriverStatisticsOption: {},

      // carOptions: [],
      height: '278px',
      option: {
        stripe: true,
        border: false,
        loading: false,
        highlightCurrentRow: false,
        serialNumber: true,
      },
      weekHourList: [],
      weekHourColumns: [{
        prop: "companyName",
        label: this.$t('common.companyName'),
        align: "center",
      },
      {
        prop: "totalWork",
        label: this.$t('VehicleAnalysis.totalWorkTime') + '(H)',
        align: "center",
        width: "100",
      },
      {
        prop: "averageWork",
        label: this.$t('HomPage.MasterKong.vehiclesDayHour'),
        align: "center",
        width: "110"
      },
      ],

      driveHourList: [],
      driveHourColumns: [{
        prop: "companyName",
        label: this.$t('HomPage.MasterKong.branchCompany'),
        align: "center",
      },
      {
        prop: "totalWork",
        label: this.$t('VehicleAnalysis.totalWorkTime') + '(H)',
        align: "center",
        width: "100",
      },
      {
        prop: "averageWork",
        label: this.$t('HomPage.MasterKong.averageWorkHours') + '(H)',
        align: "center",
        width: "110"
      },
      ],

      map: null,
      isShow: true,
      dayLoading: false,
      dayOption: {},

      // weather: {},
      date: '',
      weekday: '',
      time: '',
      iFullScreen: false,

      longitude: '',
      latitude: '',

      view: '',
      mapZoom: '',
      centerPoint: '',

      cities: []
    };
  },

  created() {
    this.imgLogo = sessionStorage.getItem("logo");
    this.getCityNumber()
    this.getData()
    this.getCarWorkTime()
    this.getDriverWorkTime()
    this.getCarAndWeightHis()
    this.getCompanyStatus()
    this.getDriverStatus()
    this.getDriverStatistics()
  },
  mounted() {
    let _this = this;
    this.timer = setInterval(() => {
      _this.date = moment().format("YYYY年MM月DD日");
      _this.time = moment().format("HH:mm:ss");
    }, 100)
    // this.getWeather()
  },
  destroyed() {
    this.map = null
    this.isShow = false
  },
  methods: {
    getLocation() {
      return new Promise((resolve, reject) => {
        var geolocation1 = new window.BMapGL.Geolocation();
        geolocation1.getCurrentPosition(function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var mk = new window.BMapGL.Marker(r.point);
            resolve({
              longitude: r.point.lng,
              latitude: r.point.lat
            })
          } else {

          }
        })
      });
    },
    // async getWeather() {
    //   const data = await this.getLocation()
    //   console.log(data)
    //   let param = {
    //     longitude: data.longitude,
    //     latitude: data.latitude
    //   }
    //   this.$store.dispatch('HomePage/GET_SELECTUSERLOCATION', param).then(res => {
    //     if (res) {
    //       this.weather = res.data.data
    //     }
    //   }).catch(err => { })
    // },
    toggleFullScreen() {
      if (screenfull.isEnabled) {
        if (!screenfull.isFullscreen) {
          this.iFullScreen = !this.iFullScreen;
          screenfull.request();
        } else {
          this.iFullScreen = !this.iFullScreen;
          screenfull.exit();
        }
      } else {
        this.$message({
          message: this.$t('HomPage.form.yourBrowserDoesNotSupportFullScreen'),
          type: "warning"
        });
      }
    },
    btnEnter() {
      this.$router.push('/VehicleManagement/VehicleFiles')
    },

    getCarAndWeightHis() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTCARDAYOVERVIEW', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.carCount = res.data.data.carCount
            this.likeCount = res.data.data.likeCount
            this.offlineCount = res.data.data.offlineCount
            this.problemCount = res.data.data.problemCount
            this.carAndWeightHis(this.carCount, this.likeCount, this.offlineCount, this.problemCount)
          }
        }
      }).catch(err => { })
    },
    carAndWeightHis(carCount, likeCount, offlineCount, problemCount) {
      const chartData = [{
        name: '车辆在线数(台)',
        value: likeCount,
        color: '#00FB82'
      },
      // {
      //   name: '车辆离线数(台)',
      //   value: offlineCount,
      //   color: '#FBA700'
      // },
      {
        name: '车辆报停数(台)',
        value: problemCount,
        color: '#FB2900'
      }
      ];
      let option = {
        title: {
          text: carCount,
          subtext: '车辆总数(台)',
          left: 'center',
          top: '34%',
          textStyle: {
            fontSize: 22,
            fontWeight: '600',
            color: '#fff'
          },
          subtextStyle: {
            fontSize: 12,
            fontWeight: 'normal',
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          position: 'right'
        },
        series: [{
          name: '车辆状态',
          type: 'pie',
          radius: ['55%', '75%'],
          center: ['50%', '52%'],
          avoidLabelOverlap: false,
          label: {
            show: false
          },
          data: chartData.map(item => ({
            value: item.value,
            name: item.name,
            itemStyle: {
              color: item.color
            }
          }))
        }]
      };
      this.carOption = option;
    },
    getCompanyStatus() {
      let obj = {
        companyName: [],
        likeCount: [],
        offlineCount: [],
        problemCount: []
      }
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTCOMPANYCAR', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              obj.companyName.push(item.companyName)
              obj.likeCount.push(item.likeCount)
              obj.offlineCount.push(item.offlineCount)
              obj.problemCount.push(item.problemCount)
            })
            this.companyStatus(obj)
          }
        }
      }).catch(err => { })
    },
    companyStatus(obj) {
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        dataZoom: [{
          type: 'slider',
          backgroundColor: 'rgba(245,245,245,.5)',
          backgroundColor: 'transparent',
          brushSelect: false,
          width: 5,
          show: true, //flase直接隐藏图形
          yAxisIndex: [0],
          //left: 'center', //滚动条靠左侧的百分比
          //bottom: 13,
          startValue: 0, //滚动条的起始位置
          endValue: 11, //滚动条的截止位置（按比例分割你的柱状图x轴长度）

          handleStyle: {
            color: '#fff',
            borderColor: 'rgba(245,245,245,.5)',
          },
          fillerColor: 'rgba(245,245,245,.5)',
          borderColor: 'transparent',
          showDetail: false,

          dataBackground: {
            areaStyle: {
              opacity: 0
            },
            lineStyle: {
              color: 'transparent'
            },
          },

        }],
        legend: {
          left: 'center',
          top: '5',
          align: 'left',
          itemGap: 30,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#F0F8FF"
          }
        },
        grid: {
          left: '2%',
          right: '8%',
          bottom: '0',
          top: '12%',
          containLabel: true,
        },
        xAxis: {
          name: '',
          type: 'value',
          axisTick: {
            show: true,
            lineStyle: {
              color: 'rgba(203, 232, 255, .6)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(203, 232, 255, .2)'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: '#F0F8FF'
            }
          },
        },
        yAxis: {
          name: '',
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 10,
              color: '#F0F8FF'
            }
          },
          data: obj.companyName
        },

        series: [{
          name: '在线数(台)',
          type: 'bar',
          stack: 'total',
          barWidth: 6,
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: '#00FB82'
          },
          data: obj.likeCount
        },

        // {
        //   name: '离线数(台)',
        //   type: 'bar',
        //   stack: 'total',
        //   barWidth: 6,
        //   label: {
        //     show: false
        //   },
        //   emphasis: {
        //     focus: 'series'
        //   },
        //   itemStyle: {
        //     color: '#FBA700'
        //   },
        //   data: obj.offlineCount
        // },

        {
          name: '报停数(台)',
          type: 'bar',
          stack: 'total',
          barWidth: 6,
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: '#FB2900'
          },
          data: obj.problemCount
        },

        ]
      }
      this.companyStatusOption = option
    },

    getDriverStatus() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTDRIVEROVERVIEW', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.driverCount = res.data.data.driverCount
            this.driverWorkCount = res.data.data.driverWorkCount
            this.driverNoWorkCount = res.data.data.driverNoWorkCount
            this.DriverStatus(this.driverCount, this.driverWorkCount, this.driverNoWorkCount)
          }
        }
      }).catch(err => { })
    },
    DriverStatus(driverCount, driverWorkCount, driverNoWorkCount) {
      let m2R2Data = [{
        value: driverWorkCount,
        name: '上岗驾驶数(名)',
        legendname: '上岗驾驶数(名)',
        itemStyle: {
          color: '#00FB82',
        },
      },
      {
        value: driverNoWorkCount,
        name: '未上岗驾驶数(名)',
        legendname: '未上岗驾驶数(名)',
        itemStyle: {
          color: '#0575FF',
        },
      },
      ]
      let nameLang = '司机数量'
      let option = {
        title: {
          text: nameLang,
          left: '0',
          top: '0',
          textStyle: {
            color: 'rgba(0, 0, 0, 0.65)',
            fontSize: 18,
            fontWeight: 'bold',
            fontFamily: 'HarmonyOS Sans SC',
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
          position: 'right'
        },
        series: [{
          name: nameLang,
          type: 'pie',
          radius: ['55%', '75%'],
          center: ['50%', '52%'],
          clockwise: false,
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              position: 'center',
              color: '#ddd',
              fontSize: 16,
              formatter: function () {
                let total = 0;
                for (let i = 0; i < m2R2Data.length; i++) {
                  const val = parseFloat(m2R2Data[i].value);
                  if (!isNaN(val)) total += val;
                }
                return `{value|${total.toFixed(0)}}\n{unit|司机总数(名)}`;
              },
              rich: {
                unit: {
                  fontSize: 12,
                  color: '#fff',
                  padding: [10, 0, 0, 0]
                },
                value: {
                  fontSize: 22,
                  fontweight: '600',
                  color: '#fff',
                  padding: [-8, 0, 0, 0]
                },
              },
            },
          },
          itemStyle: {
            borderType: 'solid',
            borderRadius: '80%',
            borderWidth: 2, // 饼图间隔距离
            borderColor: '#081831',
          },
          data: m2R2Data,
        },
        {
          name: '内边框',
          type: 'pie',
          radius: ['50%', '49%'],
          center: ['50%', '52%'],
          emphasis: {
            disabled: true // 完全禁用
            // scale: false, //鼠标移入变大
            // scaleSize: 1.05
          },
          tooltip: {
            show: false
          },
          label: {
            show: false,
            position: 'center',
            formatter: function (params) {
              return `${Number(params.value).toFixed(1)}%`
            },
            color: '#fff',
            fontSize: 30
          },
          labelLine: {
            show: false
          },
          animation: false,
          data: [{
            value: 1,
            itemStyle: {
              color: 'rgba(250,250,250,0.3)'
            }
          }]
        }
        ],
      }
      this.DriverStatusOption = option
    },
    getDriverStatistics() {
      let obj = {
        companyName: [],
        driverCount: [],
        totalWork: [],
        averageWork: []
      }
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTCOMPANYDRIVER', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              obj.companyName.push(item.companyName)
              obj.driverCount.push(item.driverCount)
              obj.totalWork.push(item.totalWork)
              obj.averageWork.push(item.averageWork)
            })
            this.DriverStatistics(obj)
          }
        }
      }).catch(err => { })
    },
    DriverStatistics(obj) {
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        dataZoom: [{
          type: 'slider',
          backgroundColor: 'rgba(245,245,245,.5)',
          backgroundColor: 'transparent',
          brushSelect: false,
          width: 5,
          show: true, //flase直接隐藏图形
          yAxisIndex: [0],
          //left: 'center', //滚动条靠左侧的百分比
          //bottom: 13,
          startValue: 0, //滚动条的起始位置
          endValue: 11, //滚动条的截止位置（按比例分割你的柱状图x轴长度）

          handleStyle: {
            color: '#fff',
            borderColor: 'rgba(245,245,245,.5)',
          },
          fillerColor: 'rgba(245,245,245,.5)',
          borderColor: 'transparent',
          showDetail: false,

          dataBackground: {
            areaStyle: {
              opacity: 0
            },
            lineStyle: {
              color: 'transparent'
            },
          },

        }],
        legend: {
          left: 'center',
          top: '5',
          align: 'left',
          itemGap: 30,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#F0F8FF"
          }
        },
        grid: {
          left: '2%',
          right: '8%',
          bottom: '0',
          top: '12%',
          containLabel: true,
        },
        xAxis: {
          name: '',
          type: 'value',
          axisTick: {
            show: true,
            lineStyle: {
              color: 'rgba(203, 232, 255, .6)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(203, 232, 255, .2)'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: '#F0F8FF'
            }
          },
        },
        yAxis: {
          name: '',
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 10,
              color: '#F0F8FF'
            }
          },
          data: obj.companyName
        },
        series: [{
          name: '司机数(名)',
          type: "bar",
          // barGrp: '30%',
          barWidth: 3,
          data: obj.driverCount,
          itemStyle: {
            color: '#0575FF',
            // borderWidth: 1,
            // borderColor: '#3167ef'
          },
          label: {
            show: false,
            // position: 'right',
            // color: '#fff'
          }
        },
        {
          name: '总工时(H)',
          type: 'bar',
          // barGrp: '30%',
          barWidth: 3,
          data: obj.totalWork,
          itemStyle: {
            color: '#00FB82',
            // borderWidth: 1,
            // borderColor: '#f8e71c'
          },
          label: {
            show: false,
            // position: 'right',
            // color: '#fff'
          }
        },
        {
          name: '平均工时(H)',
          type: 'bar',
          // barGrp: '30%',
          barWidth: 3,
          data: obj.averageWork,
          itemStyle: {
            color: '#00E0FB',
            // borderWidth: 1,
            // borderColor: '#f8e71c'
          },
          label: {
            show: false,
            // position: 'right',
            // color: '#fff'
          }
        },
        ],
      };
      this.DriverStatisticsOption = option
    },

    getData() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomePage/GET_QUERYCARDATA', param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            this.carOptions = res.data.data
            this.map = new BMapGL.Map(this.$refs.allmap);
            var arr = [];
            res.data.data.map((item) => {
              var point = new BMapGL.Point(item.longitude, item.latitude);
              arr.push(point);
            });
            // this.view = this.map.getViewport(eval(arr));
            // this.mapZoom = this.view.zoom;
            // this.centerPoint = this.view.center;
            // this.map.centerAndZoom(new BMapGL.Point(117.187890, 31.690470), 10);
            this.initMap()
          }
        }
      }).catch(err => { })
    },

    getCityNumber() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTCITYCAR', param).then(res => {
        if (res) {
          console.log(res)
          if (res.data.code == 200) {
            this.cities = res.data.data
          }
        }
      }).catch(err => { })
    },

    initMap() {
      this.map = new BMapGL.Map(this.$refs.allmap);
      this.map.setMapStyleV2({
        styleId: 'de473f98c1e9816993b6c94fe603b871'
      });
      this.map.centerAndZoom(new BMapGL.Point(117.187890, 31.690470), 5.5);
      this.map.addControl(new BMapGL.MapTypeControl({
        mapTypes: [
          BMAP_NORMAL_MAP,
          BMAP_HYBRID_MAP,
          BMAP_EARTH_MAP
        ]
      }));
      this.map.setMapType(BMAP_EARTH_MAP);
      this.map.enableScrollWheelZoom(true);

      this.map.setDisplayOptions({
        enableHighResolution: true,
        // 确保标签贴合地面
        enable3DLable: false  // 禁用标签的3D效果
      });

      // 存储车辆图标和城市标签的引用
      this.vehicleMarkers = [];
      this.cityLabels = [];
      // this.markerClusterer = null;

      // 1. 创建车辆图标（先不添加到地图）
      this.createVehicleMarkers();

      // 2. 创建城市标签（初始时添加到地图）
      this.createCityLabels();

      // 3. 根据初始缩放级别设置显示内容
      // this.updateDisplayBasedOnZoom(this.map.getZoom());

      // 4. 监听地图缩放事件
      this.map.addEventListener('zoomend', () => {
        this.handleZoomChange();
        // const currentZoom = this.map.getZoom();
        // console.log('当前缩放级别:', currentZoom, '应显示:', currentZoom >= 6 ? '车辆' : '城市标签');
        // this.updateDisplayBasedOnZoom(currentZoom);
      });

      setTimeout(() => {
        this.handleZoomChange();
      }, 100);

    },

    createCustomLabelOverlay(city, zoom) {
      const componentInstance = this;

      function CustomLabelOverlay(point, content, style) {
        this._point = point;
        this._content = content;
        this._style = style;
        this._isVisible = true; // 新增属性记录可见性
      }

      CustomLabelOverlay.prototype = new BMapGL.Overlay();

      CustomLabelOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMapGL.Overlay.getZIndex(this._point.lat);
        div.style.cursor = "pointer";

        // 应用样式
        Object.keys(this._style).forEach(key => {
          div.style[key] = this._style[key];
        });

        div.innerHTML = this._content;
        map.getPanes().labelPane.appendChild(div);

        // 添加事件
        var that = this;
        div.addEventListener("mouseover", function () {
          componentInstance.setLabelContentOnHover(that, city);
          componentInstance.setLabelStyleByZoom(that, componentInstance.map.getZoom(), true);
        });

        div.addEventListener("mouseout", function () {
          that._div.innerHTML = city.cityCarCount;
          componentInstance.setLabelStyleByZoom(that, componentInstance.map.getZoom());
        });

        return div;
      };

      CustomLabelOverlay.prototype.draw = function () {
        var map = this._map;
        var pixel = map.pointToOverlayPixel(this._point);

        // 检查点是否在可视区域内
        var bounds = map.getBounds();
        var point = this._point;
        var inBounds = bounds.containsPoint(point);

        if (inBounds) {
          // 点在可视区域内，显示标签
          this._div.style.left = pixel.x - parseInt(this._style.width || '28px') / 2 + "px";
          this._div.style.top = pixel.y - parseInt(this._style.height || '28px') - 10 + "px";
          this._div.style.display = "block"; // 显示标签
          this._isVisible = true;
        } else {
          // 点不在可视区域内，隐藏标签
          this._div.style.display = "none"; // 隐藏标签
          this._isVisible = false;
        }
      };

      // 添加方法来更新内容和样式
      CustomLabelOverlay.prototype.setContent = function (content) {
        if (this._div) {
          this._div.innerHTML = content;
        }
        this._content = content;
      };

      CustomLabelOverlay.prototype.setStyle = function (style) {
        if (this._div) {
          Object.keys(style).forEach(key => {
            this._div.style[key] = style[key];
          });
        }
        this._style = style;
      };

      // 新增方法来检查是否可见
      CustomLabelOverlay.prototype.isVisible = function () {
        return this._isVisible;
      };

      return new CustomLabelOverlay(
        new BMapGL.Point(city.longitude, city.latitude),
        this.getLabelContentByZoom(city, zoom),
        this.getLabelStyleObjectByZoom(zoom)
      );
    },
    getLabelStyleObjectByZoom(zoom) {
      let style = {};

      if (zoom < 5) {
        style = {
          color: "#fff",
          fontSize: "10px",
          width: "20px",
          height: "20px",
          lineHeight: "20px",
          borderRadius: "50%",
          backgroundColor: "#0575ff",
          textAlign: "center",
          fontWeight: "normal",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.3)",
          border: "1px solid rgba(255,255,255,0.5)",
          cursor: "default",
          userSelect: "none"
        };
      } else if (zoom >= 5 && zoom < 7) {
        style = {
          color: "#fff",
          fontSize: "12px",
          width: "24px",
          height: "24px",
          lineHeight: "24px",
          borderRadius: "50%",
          backgroundColor: "#0575ff",
          textAlign: "center",
          fontWeight: "normal",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.4)",
          border: "1px solid rgba(255,255,255,0.5)",
          cursor: "default",
          userSelect: "none"
        };
      } else {
        style = {
          color: "#fff",
          fontSize: "14px",
          width: "28px",
          height: "28px",
          lineHeight: "28px",
          borderRadius: "50%",
          backgroundColor: "#0575ff",
          textAlign: "center",
          fontWeight: "normal",
          boxShadow: "0px 3px 8px rgba(0,0,0,0.5)",
          border: "1px solid rgba(255,255,255,0.5)",
          cursor: "default",
          userSelect: "none"
        };
      }

      return style;
    },


    createVehicleMarkers() {
      var imgOnPic = new Image()
      imgOnPic.src = imgOn
      // var imgOffPic = new Image()
      // imgOffPic.src = imgOff
      var imgDisablePic = new Image()
      imgDisablePic.src = imgDisable

      // this.vehicleMarkers = []; // 清空之前的标记

      this.carOptions.forEach((item) => {
        let icon = ''
        if (item.linkState === 0) {
          icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(25, 32), {
            anchor: new BMapGL.Size(10, 30)
          });
        }
        // else if (item.linkState === 1) {
        //   icon = new BMapGL.Icon(imgOffPic, new BMapGL.Size(25, 32), {
        //     anchor: new BMapGL.Size(10, 30)
        //   });
        // } 
        else {
          icon = new BMapGL.Icon(imgDisablePic, new BMapGL.Size(25, 32), {
            anchor: new BMapGL.Size(10, 30)
          });
        }

        var points = new BMapGL.Point(item.longitude, item.latitude);
        var marker = new BMapGL.Marker(points, {
          icon: icon
        });

        // 添加点击事件
        this.openInfo(marker, points, item);
        this.vehicleMarkers.push(marker);
      });
    },

    // 创建城市标签的方法
    createCityLabels() {
      // this.cityLabels = []; // 清空之前的标签

      // this.cities.forEach(city => {
      //   // const label = new BMapGL.Label(city.cityCarCount, {
      //   //   position: new BMapGL.Point(city.longitude, city.latitude)
      //   // });
      //   const label = new BMapGL.Label(this.getLabelContentByZoom(city, this.map.getZoom()), {
      //     position: new BMapGL.Point(city.longitude, city.latitude),
      //     altitude: 0
      //   });
      //   this.setLabelStyleByZoom(label, this.map.getZoom());
      //   const componentInstance = this;
      //   label.addEventListener("mouseover", function (e) {
      //     componentInstance.setLabelContentOnHover(this, city);
      //     componentInstance.setLabelStyleByZoom(this, componentInstance.map.getZoom(), true);
      //   });
      //   label.addEventListener("mouseout", function (e) {
      //     this.setContent(city.cityCarCount);
      //     componentInstance.setLabelStyleByZoom(this, componentInstance.map.getZoom());
      //   });
      //   this.map.addOverlay(label);
      //   this.cityLabels.push(label);
      // });
      this.cities.forEach(city => {
        const overlay = this.createCustomLabelOverlay(city, this.map.getZoom());
        this.map.addOverlay(overlay);
        this.cityLabels.push(overlay);
      });
    },

    setLabelStyleByZoom(label, zoom, isHover = false) {
      let style = {};

      if (zoom < 5) {
        // 小缩放级别 - 小标签
        style = {
          color: isHover ? "#fff" : "#fff",
          fontSize: "10px",
          width: isHover ? "60px" : "20px",
          height: "20px",
          lineHeight: "20px",
          borderRadius: isHover ? "5%" : "50%",
          backgroundColor: isHover ? "#ff6b6b" : "#0575ff",
          borderColor: isHover ? "#ff6b6b" : "#0575ff",
          textAlign: "center",
          fontWeight: isHover ? "bold" : "normal",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.3)", // 添加阴影效果，看起来更贴合地面
          zIndex: 1000, // 确保标签在合适层级
          border: "1px solid rgba(255,255,255,0.5)"
        };
      } else if (zoom >= 5 && zoom < 7) {
        // 中等缩放级别 - 中等标签
        style = {
          color: isHover ? "#fff" : "#fff",
          fontSize: "12px",
          width: isHover ? "60px" : "24px",
          height: "24px",
          lineHeight: "24px",
          borderRadius: isHover ? "5%" : "50%",
          backgroundColor: isHover ? "#ff6b6b" : "#0575ff",
          borderColor: isHover ? "#ff6b6b" : "#0575ff",
          textAlign: "center",
          fontWeight: isHover ? "bold" : "normal",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.4)",
          zIndex: 1000,
          border: "1px solid rgba(255,255,255,0.5)"
        };
      } else {
        // 大缩放级别 - 大标签
        style = {
          color: isHover ? "#fff" : "#fff",
          fontSize: "14px",
          width: isHover ? "60px" : "28px",
          height: "28px",
          lineHeight: "28px",
          borderRadius: isHover ? "5%" : "50%",
          backgroundColor: isHover ? "#ff6b6b" : "#0575ff",
          borderColor: isHover ? "#ff6b6b" : "#0575ff",
          textAlign: "center",
          fontWeight: isHover ? "bold" : "normal",
          boxShadow: "0px 3px 8px rgba(0,0,0,0.5)",
          zIndex: 1000,
          border: "1px solid rgba(255,255,255,0.5)"
        };
      }

      label.setStyle(style);
    },

    getLabelContentByZoom(city, zoom) {
      if (zoom < 5) {
        // 小缩放级别 - 只显示数字
        return city.cityCarCount;
      } else if (zoom >= 5 && zoom < 7) {
        // 中等缩放级别 - 显示简短内容
        return city.cityCarCount > 999 ? Math.floor(city.cityCarCount / 1000) + 'k' : city.cityCarCount;
      } else {
        // 大缩放级别 - 显示完整信息
        return city.cityCarCount;
      }
    },

    setLabelContentOnHover(label, city) {
      label.setContent(city.name + ':' + city.cityCarCount);
    },

    updateCityLabelsSize() {
      const zoom = this.map.getZoom();

      this.cityLabels.forEach((label, index) => {
        // 更新内容
        const city = this.cities[index];
        label.setContent(this.getLabelContentByZoom(city, zoom));

        // 更新样式
        this.setLabelStyleByZoom(label, zoom);
      });
    },

    handleZoomChange() {
      const zoom = this.map.getZoom();
      console.log('当前缩放级别:', zoom);

      if (zoom >= 7) {
        // 放大地图：显示车辆，隐藏城市标签
        this.showVehicleMarkers();
        this.hideCityLabels();
      } else {
        // 缩小地图：显示城市标签，隐藏车辆
        this.updateCityLabelsSize();
        this.showCityLabels();
        this.hideVehicleMarkers();
      }
    },

    // 根据缩放级别更新显示
    // updateDisplayBasedOnZoom(zoomLevel) {
    //   const isZoomedIn = zoomLevel >= 6; // 你可以调整这个阈值

    //   if (isZoomedIn) {
    //     // 放大地图：显示车辆，隐藏城市标签
    //     this.showVehicleMarkers();
    //     this.hideCityLabels();
    //   } else {
    //     // 缩小地图：显示城市标签，隐藏车辆
    //     this.showCityLabels();
    //     this.hideVehicleMarkers();
    //   }
    // },

    // 显示城市标签
    showCityLabels() {
      this.hideCityLabels();
      this.updateCityLabelsSize();

      // 逐个添加城市标签到地图
      this.cityLabels.forEach(label => {
        try {
          this.map.addOverlay(label);
        } catch (e) {
          console.error('添加城市标签失败:', e);
        }
      });
    },

    // 隐藏城市标签
    hideCityLabels() {
      this.cityLabels.forEach(label => {
        try {
          this.map.removeOverlay(label);
        } catch (e) {
          // 忽略移除不存在的覆盖物的错误
        }
      });
    },

    // 显示车辆标记（使用点聚合）
    showVehicleMarkers() {
      this.hideVehicleMarkers();

      // 逐个添加车辆图标到地图
      this.vehicleMarkers.forEach(marker => {
        try {
          this.map.addOverlay(marker);
        } catch (e) {
          console.error('添加车辆图标失败:', e);
        }
      });
    },

    // 隐藏车辆标记
    hideVehicleMarkers() {
      this.vehicleMarkers.forEach(marker => {
        try {
          this.map.removeOverlay(marker);
        } catch (e) {
          // 忽略移除不存在的覆盖物的错误
        }
      });
    },

    openInfo(markers, points, item) {
      var opts = {
        width: 250,
        height: 300,
      };
      var infoWindow = new BMapGL.InfoWindow(
        this.$t('common.carId') + ':' + item.carId + "<br />" +
        this.$t('common.manufactureNum') + ':' + item.manufactureNum + "<br />" +
        this.$t('common.terminalId') + ':' + item.terminalId + "<br />" +
        this.$t('common.orgName') + ':' + item.orgName + "<br />" +
        this.$t('common.messageTime') + ':' + item.messageTime + "<br />" +
        this.$t('common.province') + ':' + item.province + "<br />" +
        this.$t('common.city') + ':' + item.city + "<br />" +
        this.$t('common.address') + ':' + item.address + "<br />",
        opts
      );
      markers.addEventListener('click', function () {
        this.map.openInfoWindow(infoWindow, points);
      });
    },
    getCarWorkTime() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTCOMPANYWORKRANK', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.weekHourList = res.data.data
          }
        }
      }).catch(err => { })
    },
    getDriverWorkTime() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
      }
      this.$store.dispatch('HomeMasterKong/GET_SELECTDRIVERWORKRANK', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.driveHourList = res.data.data
          }
        }
      }).catch(err => { })
    },
  },
};